import { getField, updateField } from "vuex-map-fields";
import { isEmpty } from "lodash-es";
import { storageGetSurvey } from "@/lib/localStorage";

const initialState = {
  survey: {
    cityId: null,
    cuisineIds: [],
  },
};

export default {
  namespaced: true,
  state: { ...initialState },
  getters: {
    getField,
    isSurveyed(state) {
      return !isEmpty(state.survey.cuisineIds);
    },
    getSurvey(state) {
      return state.survey;
    },
    getCuisineIds(state) {
      return state.survey.cuisineIds;
    },
  },
  mutations: {
    updateField,
    setState(state, payload) {
      state[payload.state] = payload.val;
    },
  },
  actions: {
    setSurvey({ state }, payload) {
      state.survey = payload;
    },
    loadSurvey({ commit }, userId) {
      const survey = storageGetSurvey(userId);
      if (survey) {
        commit("setState", { state: "survey", val: survey });
      }
    },
  },
};
